import { useCallback, useEffect, useRef, useState } from 'react'
import ServicoAPI from '../../servicos/ServicoAPI'
import { print } from '../../servicos/Uteis'
import ScannerLeituraModal from './ScannerLeituraModal.jsx'

export default function ScannerColetaModal({ open, onClose, idServico, dados, onSuccess }) {
	const [erro, setErro] = useState('')
	const [enviando, setEnviando] = useState(false)
	const [leituraPausada, setLeituraPausada] = useState(false)
	const ultimoCodigoRef = useRef('')
	const enviandoRef = useRef(false)

	useEffect(() => {
		if (!open) {
			setErro('')
			setLeituraPausada(false)
			ultimoCodigoRef.current = ''
			enviandoRef.current = false
		}
	}, [open])

	const retomarLeitura = useCallback(() => {
		setErro('')
		setLeituraPausada(false)
		ultimoCodigoRef.current = ''
		enviandoRef.current = false
	}, [])

	const handleClose = useCallback(() => {
		setErro('')
		setLeituraPausada(false)
		ultimoCodigoRef.current = ''
		enviandoRef.current = false
		onClose?.()
	}, [onClose])

	const enviarCodigo = useCallback(async (codigo) => {
		if (!codigo || enviandoRef.current || leituraPausada) return
		if (ultimoCodigoRef.current === codigo) return

		enviandoRef.current = true
		ultimoCodigoRef.current = codigo
		setEnviando(true)
		setErro('')

		try {
			const res = await ServicoAPI.informarCodigo('/receberNumeroNota', 'POST', dados, {
				idProf: dados.idProf,
				idServico: idServico,
				conteudoScan: codigo
			})

			if (res?.resultado) {
				print(res.mensagem || 'Coleta confirmada com sucesso')
				onSuccess?.()
				handleClose()
			} else {
				setErro(res?.mensagem || 'Endereço não encontrado para este código.')
				setLeituraPausada(true)
			}
		} catch {
			setErro('Falha ao enviar o código. Tente novamente.')
			setLeituraPausada(true)
		} finally {
			enviandoRef.current = false
			setEnviando(false)
		}
	}, [dados, handleClose, idServico, leituraPausada, onSuccess])

	return (
		<ScannerLeituraModal
			open={open}
			onClose={handleClose}
			onCodigoLido={enviarCodigo}
			elementId="scanner-coleta-reader"
			processando={enviando}
			mensagemProcessando="Enviando..."
			mensagemRodape="Aponte para o código com a câmera traseira. O envio ocorre automaticamente após a leitura."
			bloquearReleitura={true}
			leituraPausada={leituraPausada}
			erroLeitura={erro}
			onRetomarLeitura={retomarLeitura}
		/>
	)
}
